import { useState } from "react";
import { RefreshCw, X } from "lucide-react";
import { useAppUpdate } from "@/hooks/useAppUpdate";

export function UpdateBanner() {
  const { updateReady, applyUpdate } = useAppUpdate();
  const [dismissed, setDismissed] = useState(false);
  const [busy, setBusy] = useState(false);
  if (!updateReady || dismissed) return null;

  return (
    <div className="fixed inset-x-3 bottom-3 z-[60] sm:left-auto sm:right-4 sm:w-80 animate-fade-up" data-testid="app-update-banner">
      <div className="rounded-2xl border border-amber-500/40 bg-panel-2/95 backdrop-blur-xl shadow-2xl p-4 flex items-center gap-3">
        <RefreshCw className={`h-5 w-5 text-amber-400 shrink-0 ${busy ? "animate-spin" : ""}`} />
        <div className="flex-1 min-w-0">
          <p className="text-sm font-semibold">Nova versão disponível</p>
          <p className="text-xs text-zinc-500">Atualize para ver as últimas melhorias.</p>
        </div>
        <button type="button" onClick={() => { setBusy(true); applyUpdate(); }} disabled={busy} data-testid="app-update-button"
          className="h-9 px-4 rounded-xl bg-amber-500 text-ink text-xs font-bold shrink-0 hover:bg-amber-400 active:scale-95 transition-all disabled:opacity-60">
          Atualizar
        </button>
        <button type="button" onClick={() => setDismissed(true)} data-testid="app-update-dismiss" aria-label="Mais tarde"
          className="h-7 w-7 -mr-1 rounded-lg text-zinc-500 hover:text-white flex items-center justify-center shrink-0">
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
